import { render, staticRenderFns } from "./CancelPolicy.vue?vue&type=template&id=b1d2642a&lang=pug"
import script from "./CancelPolicy.vue?vue&type=script&lang=js"
export * from "./CancelPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports